<script lang="ts">
import { useDisplay } from 'vuetify'
import PwaInstall from '~/components/menu/PwaInstall.vue'

export default {
    name: 'NavigationSidebar',
    components: { PwaInstall },
    props: {
        rail: { type: Boolean, required: true, default: false },
    },
    emits: ['desktopMode'],
    data() {
        const { mobile } = useDisplay()
        return {
            mobile,
        }
    },
    computed: {
        isLoggedIn() {
            return this.$currentUser().k
        },
    },
    methods: {
    },
}
</script>

<template>
    <div>
        <v-list-item nav>
            <div class="w-100 text-center">
                <img v-if="!rail" src="@/assets/images/logo-cleaned.png" alt="Logo Serpic" width="100">
                <img v-else src="@/assets/images/logo-alone.png" alt="Logo Serpic" width="30" class="py-2">
            </div>
        </v-list-item>

        <v-divider />

        <PwaInstall />

        <v-list density="compact" nav>
            <NuxtLink to="/">
                <v-list-item prepend-icon="mdi mdi-application-outline" value="home">
                    <v-list-item-title>Accueil</v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <NuxtLink v-if="$permissionCheck('declaration_write_burns_from_homepage')" to="/ajouter-date-brulage">
                <v-list-item prepend-icon="mdi-plus" value="ajouter-date-brulage">
                    <v-list-item-title>Déclarer un brulâge</v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <NuxtLink v-if="$permissionCheck('declaration_write_burns_from_homepage')" to="/declarer-fin-brulage">
                <v-list-item prepend-icon="mdi-fire-off" value="declarer-fin-brulage">
                    <v-list-item-title>Déclarer la fin d'un brûlage</v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <NuxtLink v-if="$permissionCheck(`dashboard_burn_page`)" to="/tableau-de-bord-brulages">
                <v-list-item prepend-icon="mdi-view-dashboard" value="dashboard-sdis">
                    <v-list-item-title>Tableau de bord brûlages</v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <NuxtLink v-if="isLoggedIn" to="/profil">
                <v-list-item prepend-icon="mdi-account" value="profil">
                    <v-list-item-title>Mon profil</v-list-item-title>
                </v-list-item>
            </NuxtLink>

            <v-list-item prepend-icon="mdi-sync">
                <v-list-item-title>
                    <p @click="$emit('desktopMode')">
                        Voir l'affichage bureau
                    </p>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </div>
</template>
